module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "beta-chip",
    style: (_vm.applyColorStyles())
  }, [_vm._v("\n  BETA\n")])
},staticRenderFns: []}